export default __webpack_public_path__ + "static/media/two_of_wands.ed3fb3cc.png";